var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$route.name !== "Register"
    ? _c(
        "div",
        { attrs: { id: "app" } },
        [
          _vm.showScrapAgent
            ? _c("scrap-agent", {
                attrs: {
                  openScrap: _vm.showScrapAgent,
                  itemSetting: _vm.selectedScrapData,
                },
                on: {
                  isModalOpenScrap: function (data) {
                    return (_vm.showScrapAgent = data)
                  },
                  updateScrapAgentSuccess: _vm.updateScrapAgentSuccess,
                  "modal:close": function ($event) {
                    _vm.showScrapAgent = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !this.$route.meta.hideNavBar
            ? _c(
                "div",
                {
                  staticStyle: { "z-index": "3500 !important" },
                  attrs: { id: "header-block" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "go-header" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("ds-navbar", { ref: "logout" }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          this.$route.meta.showGuestNavBar ? _c("ds-navbar-guest") : _vm._e(),
          _vm._v(" "),
          _vm.authenticated
            ? _c("my-report-sidebar", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: this.$route.meta.showMyReportSidebar,
                    expression: "this.$route.meta.showMyReportSidebar",
                  },
                ],
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.authenticated
            ? _c("my-briefing-sidebar", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      this.$route.meta.showMyBriefingSidebar &&
                      !_vm.$store.getters[
                        "briefingStore/getCompanyWidgetDetail"
                      ].name &&
                      !_vm.isGuest,
                    expression:
                      "this.$route.meta.showMyBriefingSidebar && !$store.getters['briefingStore/getCompanyWidgetDetail'].name && !isGuest",
                  },
                ],
                ref: "userSidebar",
              })
            : _vm._e(),
          _vm._v(" "),
          this.$route.meta.showSideBarMyCreate
            ? _c("my-create-sidebar")
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "go-container-block",
              staticStyle: { "overflow-y": "scroll" },
              attrs: { id: "container-block" },
              on: {
                "&scroll": function ($event) {
                  return _vm.handleScroll.apply(null, arguments)
                },
              },
            },
            [
              _vm.isShowButtonGoToTop
                ? _c("go-to-top-component", {
                    attrs: {
                      "is-show-button-go-to-top": _vm.isShowButtonGoToTop,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.scrollToTop.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "keep-alive",
                [
                  _c("router-view", {
                    on: { reloadBriefingPage: _vm.reloadBriefingPage },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("logout", { on: { logout: _vm.logout } }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isShowDetailArticle
            ? _c("article-detail", {
                attrs: { items: this.getSelectedResource },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.companyWidgetDetail &&
          _vm.companyWidgetDetail.name &&
          _vm.getCompanyBpDetail &&
          _vm.getCompanyBpDetail.stockCode
            ? _c("company-widget-view-detail", {
                attrs: { widgetData: _vm.companyWidgetDetail.widgetData },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isShowDetailReport
            ? _c("report-detail", {
                attrs: { items: this.getSelectedResource },
                on: {
                  selectComponent: _vm.selectComponent,
                  contentReference: _vm.getAllContentReference,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isShowDetailTopic
            ? _c("topic-detail", { attrs: { items: this.getSelectedResource } })
            : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowEditReportRef
            ? _c("popup-edit-report-ref", {
                attrs: {
                  items: this.getSelectedResource,
                  arrDocId: this.arrDocId,
                  contentReference: this.listContentReference,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isShowCreateBriefing
            ? _c("modal-create-agent-component", {
                on: {
                  reloadBriefingPage: _vm.reloadBriefingPage,
                  handleRemoveToastReportDataByListRequestIds:
                    _vm.handleRemoveToastReportDataByListRequestIds,
                  reportTypesResult: _vm.getReportTypesResult,
                  reportTypesResultForBriefing:
                    _vm.getReportTypesResultForBriefing,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isShowAddReference ? _c("add-reference") : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowUpdateBriefing ? _c("popup-update-briefing") : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowAlertPinBriefing ? _c("popup-alert-pin") : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowShareReport ? _c("share-report") : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowShareTopic ? _c("share-topic") : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowReportSettingReportType
            ? _c("popup-report-detail-setting-component")
            : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowPopupSubmitReport ? _c("popup-submit-report") : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowPopupSubmitReportSuccess
            ? _c("popup-submit-report-success")
            : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowReportWarningCloseAfterEdit
            ? _c("popup-report-warning-close-after-edit-component")
            : _vm._e(),
          _vm._v(" "),
          _c("popup-plugin-download"),
          _vm._v(" "),
          _vm.getToastReportData && _vm.getToastReportData.length > 0
            ? _c(
                "div",
                {
                  staticClass: "go-toast-wrap",
                  staticStyle: { bottom: "50px", "z-index": "99999" },
                },
                _vm._l(
                  _vm.getToastReportData,
                  function (toastReportItem, index) {
                    return _c("report-toast-component", {
                      key:
                        toastReportItem &&
                        toastReportItem.requestId &&
                        index &&
                        index + "_" + toastReportItem.requestId,
                      style: {
                        marginBottom:
                          index === _vm.getToastReportData.length - 1
                            ? "0px"
                            : "10px",
                      },
                      attrs: {
                        toastReportItem: toastReportItem,
                        reportTypesResult: toastReportItem.reportTypesResult,
                        reportTypesResultForBriefing:
                          toastReportItem.reportTypesResultForBriefing,
                      },
                      on: {
                        handleRemoveToastReportDataByRequestId:
                          _vm.handleRemoveToastReportDataByRequestId,
                        handleOpenReportDetail: _vm.handleOpenReportDetail,
                        handleGoToBriefingPage: _vm.handleGoToBriefingPage,
                        handleGoToPage: _vm.handleGoToPage,
                      },
                    })
                  }
                ),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("popup-trial-exist-user"),
          _vm._v(" "),
          _vm.getIsShowPopupLogin ? _c("popup-login") : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowPopupRequiredLogin
            ? _c("popup-required-login-component")
            : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowPopupRegister ? _c("popup-register") : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowPopupRequiredPaidAccount
            ? _c("popup-required-paid-account-component")
            : _vm._e(),
          _vm._v(" "),
          _vm.getIsShowFeatureLimit ? _c("popup-feature-limit") : _vm._e(),
          _vm._v(" "),
          _vm.isShowAddReference ||
          _vm.getIsShowUpdateBriefing ||
          _vm.getIsShowDeleteBriefing ||
          _vm.getIsShowBackdrop ||
          _vm.getIsShowReportSettingReportType ||
          _vm.getIsShowReportWarningCloseAfterEdit ||
          _vm.getIsShowPopupSubmitReport ||
          _vm.getIsShowPopupSubmitReportSuccess ||
          _vm.getIsOpenPopupEditReferenceForPage ||
          _vm.getIsShowPopupRequiredLogin ||
          _vm.getIsShowPopupLogin ||
          _vm.getIsShowPopupRequiredPaidAccount ||
          _vm.getIsShowPopupRegister ||
          _vm.getIsShowFeatureLimit ||
          _vm.showScrapAgent ||
          _vm.isShowDetailArticle ||
          _vm.isShowDetailReport ||
          _vm.isShowDetailTopic ||
          _vm.isShowCreateBriefing
            ? _c("div", {
                staticClass: "modal-backdrop fade show",
                staticStyle: { "z-index": "1030 !important" },
              })
            : _vm._e(),
        ],
        1
      )
    : _c("div", { attrs: { id: "app" } }, [_c("register")], 1)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-brand" }, [
      _c(
        "a",
        {
          staticClass: "go-logo",
          attrs: { href: "https://intro.goover.ai", target: "_blank" },
        },
        [
          _c("img", {
            attrs: {
              alt: "goover",
              src: "content/images/images_v3/common/go-goover-symbol.png",
            },
          }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }